// extracted by mini-css-extract-plugin
export var content = "steps-module--content--3pXd2";
export var step = "steps-module--step--2Fj6_";
export var illustration = "steps-module--illustration--2M5tx";
export var card = "steps-module--card--1jYy9";